import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';




export const VehicleRegistrationCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    /* API Call Post Method */
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    //Driver Registration create
    const [description, setDescription] = useState("");
    const [vehicleNo, setVehicleNo] = useState("");
    const [taxDueDate, setTaxDueDate] = useState("");
    const [insuranceDueDate, setInsuranceDueDate] = useState("");
    const [serviceDueDate, setServiceDueDate] = useState("");
    const [permitValidity, setPermitValidity] = useState("");
    const [polutionDueDate, setPolutionDueDate] = useState("");
    const [tierChangeDate, setTierChangeDate] = useState("");
    const [additionalValidity, setAdditionalValidity] = useState("");
    const [fitnessValidity, setfitnessValidity] = useState("");
    const [registrationValidity, setregistrationValidity] = useState("");
    const [insuranceCompany, setInsuranceCompany] = useState("");
    const [advertisementValidity, setadvertisementValidity] = useState("");
    const [remarks, setRemarks] = useState("");
    const [VehicletypeId, setVehicleTypeid] = useState("");
    const [chassisno, setChassisNo] = useState("");
    const [engineNo, setEngineNo] = useState("");
    const [rcOwner, setRCOwner] = useState("");
    const [driverName, setDriverName] = useState("");
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");

    const [VehicleTypeOptions, setVehicleTypeoptions] = useState([]);
    const [selectedRouteType, setSelectedRouteType] = useState(null);

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('VehicleTypeApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(vehicletype => ({
                    value: vehicletype.id,
                    label: vehicletype.name
                }));
                setVehicleTypeoptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    useEffect(() => {
        fetchRouteTypes();
    }, [companyId, token]);

    const handleRouteTypeChange = (selectedOption) => {
        setSelectedRouteType(selectedOption);
    };

    // onChange={(e) => {
    //     const selectedValue = e.target.value;
    //     selectedRouteType(selectedValue);
    //     setFormData((prevFormData) => ({
    //         ...prevFormData,
    //         VehicletypeId: selectedValue,
    //     }));
    // }}

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!description || !vehicleNo) {
            setErrorMessages("All fields are required!");
            setIsLoading(false);
            return;
        }

        try {
            const VehicleCreateData = {

                VehicletypeId: selectedRouteType.value, // Handle case when selectedUserType is null
                CompanyID: companyId,
                Description: description,
                VehicleNo: vehicleNo,
                TaxDueDate: taxDueDate,
                InsuranceDueDate: insuranceDueDate,
                ServiceDueDate: serviceDueDate,
                PermitValidity: permitValidity,
                PolutionDueDate: polutionDueDate,
                TierChangeDate: tierChangeDate,
                AdditionalValidity: additionalValidity,
                FitnessValidity: fitnessValidity,
                RegistrationValidity: registrationValidity,
                InsuranceCompany: insuranceCompany,
                AdvertisementValidity: advertisementValidity,
                Remarks: remarks,

                ChassisNo: chassisno,
                EngineNo: engineNo,
                RCOwner: rcOwner,
                DriverName: driverName,
                CreatedBy: userId,
                CreatedDate: new Date(),
            };

            postData('VehicleApi', VehicleCreateData, token)
                .then((response) => {
                    console.log('VehicleRegistration Created success:', response);
                    setDescription("");
                    setVehicleNo("");
                    setTaxDueDate("");
                    setInsuranceDueDate("");
                    setServiceDueDate("");
                    setPermitValidity("");
                    setPolutionDueDate("");
                    setTierChangeDate("");
                    setAdditionalValidity("");
                    setfitnessValidity("");
                    setAdditionalValidity("");
                    setChassisNo("");
                    setDriverName("");
                    setEngineNo("");
                    setInsuranceCompany("");
                    setRCOwner("");
                    setVehicleTypeid("");
                    setadvertisementValidity("");
                    setSuccessMessages("VehicleRegistration Created successful!");
                    setErrorMessages(""); // Clear error message on success
                    history.push('/VehicleRegistrationIndex');

                    setTimeout(() => {
                        setSuccessMessages("");
                    }, 3000); // 3 seconds
                })
                .catch((error) => {
                    console.error('VehicleRegistration Create error:', error);
                    setIsLoading(false);
                });


        }
        catch (error) {
            console.error('VehicleRegistration Create error:', error);
        }
    };


    /* End API */

    return (

        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='uppercase productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Vehicle Registration</h6>

                        <Tooltip title="Exit">
                            <Link to="/VehicleRegistrationIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Exit <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>
                    {errorMessages && <p className="text-red-500">{errorMessages}</p>}
                    {successMessages && <p className="text-green-500">{successMessages}</p>}

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Vehicle Type
                            </label>
                            <Select
                                value={selectedRouteType}
                                onChange={handleRouteTypeChange}
                                options={VehicleTypeOptions}
                                placeholder="Select Vehicle Type"
                                isSearchable
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Vehicle Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                type="text"
                                placeholder="Enter Name"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Vehicle No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={vehicleNo}
                                onChange={(e) => setVehicleNo(e.target.value)}
                                type="text"
                                placeholder="Enter VehicleNo"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Driver Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={driverName}
                                onChange={(e) => setDriverName(e.target.value)}
                                type="text"
                                placeholder="Enter Driver Name"
                            />
                        </div>


                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Engine No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={engineNo}
                                onChange={(e) => setEngineNo(e.target.value)}
                                type="text"
                                placeholder="Enter Engine No"
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                RC Owner
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={rcOwner}
                                onChange={(e) => setRCOwner(e.target.value)}
                                type="text"
                                placeholder="Enter RC Owner"
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Insurance Company
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={insuranceCompany}
                                onChange={(e) => setInsuranceCompany(e.target.value)}
                                type="text"
                                placeholder="Enter Insurance Company"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Chassis No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={chassisno}
                                onChange={(e) => setChassisNo(e.target.value)}
                                type="text"
                                placeholder="Enter Chassis No"
                            />
                        </div>
                    </div>


                    {/* <div className="w-full mb-4 flex flex-wrap"> */}
                    <div className="w-full mb-4 flex">
                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Tax Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={taxDueDate} onChange={(e) => setTaxDueDate(e.target.value)}
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Insurance Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={insuranceDueDate} onChange={(e) => setInsuranceDueDate(e.target.value)}
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Service Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={serviceDueDate} onChange={(e) => setServiceDueDate(e.target.value)}
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Pollution Due Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={polutionDueDate} onChange={(e) => setPolutionDueDate(e.target.value)}
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Tyre Change Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={tierChangeDate} onChange={(e) => setTierChangeDate(e.target.value)}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Permit Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={permitValidity} onChange={(e) => setPermitValidity(e.target.value)}
                            />
                        </div>

                    </div>

                    <div className="w-full mb-4 flex flex-wrap">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Additional Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={additionalValidity} onChange={(e) => setAdditionalValidity(e.target.value)}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Fitness Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={fitnessValidity} onChange={(e) => setfitnessValidity(e.target.value)}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Registration Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={registrationValidity} onChange={(e) => setregistrationValidity(e.target.value)}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Advertisement Validity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" value={advertisementValidity} onChange={(e) => setadvertisementValidity(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* <div className="w-1/2 mb-4 flex">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="remarks">
                            Remarks
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            type="text"
                            placeholder="Enter Remarks"
                        />
                    </div> */}
                    <div className="w-1/2 mb-4 flex flex-col">
                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                            Remarks
                        </label>
                        <textarea
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            placeholder="Enter Remarks"
                            rows="4"
                        />
                    </div>



                </form>



            </div >

        </Fragment >
    );
}

